import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LookupModel } from 'libs/shared/src/lib/models/lookup.model';
import { AlertModel } from '../../models/alert.model';
import { CommonDashboardItemModel } from '../../models/common-dashboard-item.model';

@Component({
  selector: 'jsg-common-dashboard-table',
  templateUrl: './common-dashboard-table.component.html',
  styleUrls: ['./common-dashboard-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonDashboardTableComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  private data: CommonDashboardItemModel[];
  get tableData(): CommonDashboardItemModel[] {
    return this.data;
  }
  @Input()
  set tableData(value: CommonDashboardItemModel[]) {
    this.data = value;
    this.dataSource = new MatTableDataSource(value);
    this.paginator.length = this.data[0]?.totalRowCount;
  }

  @Input() categories: LookupModel[];
  @Input() alerts: AlertModel[];
  @Input() pageInfo: PageEvent;

  selectedFilters = {
    categoryCode: [],
  };
  filterOverlayStates: any = {};
  displayedColumns: string[] = [
    'actionNumber',
    'styleOfCause',
    'jurisdiction',
    'category',
  ];
  dataSource = new MatTableDataSource<CommonDashboardItemModel>();

  @Output() view = new EventEmitter<string>();

  @Output() areaOfLawChange = new EventEmitter<string>();
  @Output() pageChange = new EventEmitter<PageEvent>();

  constructor(private detectorRef: ChangeDetectorRef) {}

  // for single/double click discrimination: https://stackoverflow.com/questions/48295288/how-to-handle-single-click-and-double-click-on-the-same-html-dom-element-usi?rq=1

  onApplyFilter() {
    this.dataSource.filter = JSON.stringify(this.selectedFilters);
  }

  onMoreFilters() {}

  onClearFilter(columnId: string) {
    delete this.selectedFilters[columnId];
    this.onApplyFilter();
  }

  onPageChange(args: PageEvent) {
    this.pageChange.emit(args);
  }

  removeFilter(key: string, value: string) {
    if (this.selectedFilters[key].includes(value)) {
      this.selectedFilters[key].splice(
        this.selectedFilters[key].indexOf(value),
        1
      );
      this.onApplyFilter();
    }
  }

  toggle(which: string) {
    this.filterOverlayStates[which] = !this.filterOverlayStates[which];
    this.detectorRef.detectChanges();
  }

  onView(element: CommonDashboardItemModel) {
    this.view.emit(element.actionNumber);
  }

  public getEndTime(startTime: Date, duration: number) {
    startTime = new Date(startTime);
    let endDate = startTime;
    return endDate.setMinutes(startTime.getMinutes() + duration);
  }
}
